import React from 'react';
import { useSelector } from 'react-redux';
import { ModalHeader } from '../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { useAddGoalMutation } from '../../api/useAddGoalMutation';
import { hasAccessToEditProfileSelector } from '../../../../CommonSelectors/CommonAreaSelector';

interface Props {
  clientId: string;
  name: string;
  message: string;
  url: string;
  onClose(): void;
}

export const AddGoalModal = ({ clientId, name, message, url, onClose }: Props) => {
  const canEdit = useSelector(hasAccessToEditProfileSelector);
  const {
    mutateAsync: addGoalMutation,
    isLoading: isAddingGoal,
    error: addGoalError,
  } = useAddGoalMutation({ clientId });

  const handleAddGoal = async () => {
    try {
      await addGoalMutation({ clientId, url });

      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'add-goal-modal--header' }}
    >
      <ModalHeader id="add-goal-modal--header">Add {name} Goal</ModalHeader>

      {addGoalError && <Alert message={addGoalError.message} variant="error" mb="16" mx="24" />}

      <ModalBody>{message}</ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose} mr="8">
          {canEdit ? 'Cancel' : 'Close'}
        </Button>

        {canEdit && (
          <Button isLoading={isAddingGoal} onClick={handleAddGoal}>
            Add Goal
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};
